import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

import { TagCommanderService } from '../../shared/tag-commander/tag-commander.service';
import { TagCommanderClickType } from '../../shared/tag-commander/tag-commander.types';
import * as fromAuthActions from '../auth/actions';
import * as fromTrackingActions from './actions';
import { getTrackPageViewData } from './helpers';

@Injectable()
export class TrackingEffects {
  readonly setUserIdForAtInternetOnAuthenticate$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(fromAuthActions.authenticate),
        tap(({ userIdForAtInternet }) => {
          if (userIdForAtInternet) {
            this.tagCommanderService.patchVars({
              user_id_AT: userIdForAtInternet,
            });
          }
        }),
      ),
    { dispatch: false },
  );

  readonly trackClick$ = createEffect(
    () =>
      this.actions.pipe(
        ofType(fromTrackingActions.trackClick),
        tap(({ label, clickType }) => {
          const { chapter, page, subSubChapter, subChapter } = getTrackPageViewData(this.router.url);
          const xtPage = [chapter, page, subChapter, subSubChapter, label].filter(Boolean).join('::');
          this.tagCommanderService.trackEventClick(clickType || TagCommanderClickType.Action, xtPage, label);
        }),
      ),
    { dispatch: false },
  );

  readonly trackPageView$ = createEffect(
    () =>
      this.router.events.pipe(
        filter<NavigationEnd>(event => event instanceof NavigationEnd),
        map(event => getTrackPageViewData(event.urlAfterRedirects)),
        concatMap(async ({ page, chapter, subChapter, subSubChapter }) => {
          if (page) {
            await this.tagCommanderService.trackPageView(page, chapter, subChapter, subSubChapter);
          }
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private readonly tagCommanderService: TagCommanderService,
    private readonly actions: Actions,
    private readonly router: Router,
  ) {}
}
